<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="pa-4">
    <v-col cols="12" xs="9" sm="8" class="pt-0 py-0" v-if="showTitle">
      <span class="headline">Benutzer</span>
    </v-col>
    <v-spacer v-if="showTitle"></v-spacer>
    <v-col cols="12" xs="3" sm="4" class="pt-0 py-0" v-if="showTitle">
      <v-text-field
          v-model="search"
          append-icon="search"
          label="Suche"
          single-line
          hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" class="pa-4">
      <v-data-table
      :headers="headers"
      :items-per-page="-1"
      :items="deviceList"
      fixed-header
      hide-default-footer
      :height="tableHeight"
      :search="search"
      >

        <template v-slot:item.name="{ item }">
          <span>
            {{item.lastname}}, {{item.forename}}
          </span>
        </template>
        <template v-slot:item.guidParent="{ item }">
            <span :style="getCompanyStyle(item)">
              {{item.companyName}}
              <span v-if="!item.companyName">Globaler Benutzer</span>
            </span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
          >
            edit
          </v-icon>
          <v-icon
          small
          @click="deleteItem(item)"
          >
            delete
          </v-icon>
        </template>
      </v-data-table>
    </v-col>
    <DialogDeleteItem ref="dlgDelete" @doDelete="doDelete"></DialogDeleteItem>
  </v-row>
</template>

<script>
import Vue from 'vue'
import DialogDeleteItem from "../dialogs/DialogDeleteItem";

export default {
  name: 'TableUser',
  props: {
    showTitle: Boolean,
    companyId: String,
    inCompany: Boolean
  },
  components: {DialogDeleteItem},
  data () {
    return {
      tableHeight: 100,
      currentDevice: null,
      search: null,
      headers: [
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Username', align: 'left', value: 'username'},
        {text: 'Firma', value: 'guidParent'},
        {text: 'Role', value: 'roleName'},
        {text: 'E-Mail', value: 'email'},
        {text: 'Telefon', value: 'phonenumber'},
        {text: 'Aktion', value: 'action'}
        /*{text: 'Erstellt', value: 'created'},
        {text: 'Kommentar', value: 'comment'}
         */
      ],
      deviceList: []
    }
  },
  methods: {
    deleteItem: function (item) {
      this.$refs.dlgDelete.open({
        type: 'Benutzer',
        id: '' + item.guid,
        name: 'Benutzer ' + item.username,
        item: item
      })
    },
    doDelete: function (item) {
      console.log('item', item)
      Vue.prototype.$apiUser.deleteItem(item.item.guid, this.reload)
    },
    openCompanyDialog: function (item) {
      console.log('openCompanyDialog', item)
      this.currentDevice = item
      this.$refs.dlgLink.open({
        title: 'Netzwerk zuweisen',
        description: 'Wählen Sie ein Netzwerk'
      })
    },
    onLinkCompany: function (item) {
      console.log('onLinkCompany', item)
      Vue.prototype.$api.linkDeviceToCompany(this.currentDevice.guid, item, this.reload)
    },
    editItem: function (item) {
      if (this.companyId) {
        this.$router.push('/Netzwerke/' + this.companyId + '/Benutzer/' + item.guid)
      } else {
        this.$router.push('/Benutzer/' + item.guid)
      }
    },
    getHDStyle: function (item) {
      var style = ''
      var prz = (100 / item.diskUsageMax) * item.diskUsageCurrent

      if (prz < 80) {
        style = 'color: green'
      } else {
        style = 'color: orange'
      }
      if (prz > 95) {
        style = 'color: red'
      }
      return style
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.companyName) {
        style = 'color: #aa4444;'
      }
      return style
    },
    toMB: function (bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
      dm = decimals <= 0 ? 0 : decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    reload: function () {
      var reqData = {}
      if (this.companyId != null) {
        reqData.guidParent = this.companyId
      }
      Vue.prototype.$apiUser.loadUser(reqData, this.onGetData)
      this.resize()
    },
    onGetData: function (result) {
      console.log('result', result)
      this.deviceList = result
    },
    resize: function () {
      this.tableHeight = window.innerHeight - 246;
      if (this.showTitle) {
        this.tableHeight = window.innerHeight - 256;
      }
      if (this.inCompany === true) {
        this.tableHeight = window.innerHeight - 400;
        if (this.showTitle) {
          this.tableHeight = window.innerHeight - 440;
        }
      }
      if (this.tableHeight < 150) {
        this.tableHeight = 150;
      }
    },
  },
  mounted () {
    var cmp = this
    this.$nextTick(() => {
      cmp.reload()
    })
  },
  created() {
    Vue.prototype.$eventHub.$on('resize', this.resize)
  },
  destroyed() {
    Vue.prototype.$eventHub.$off('resize', this.resize)
  }
}
</script>

<style scoped>

</style>
